import { GeneralInfo } from './../../../VIewModels/TowLocateViewModels/GeneralInfo';
import { MultipleResultServiceService } from './../../../Services/TowLocateServices/multiple-result-service.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SearchByVinViewModel } from '../../../ViewModels/TowLocateViewModels/SerchbyVinViewModel';
import { TowLocateSubjectService } from '../../../services/TowLocateServices/tow-locate-subject.service';

@Component({
  selector: 'app-multiple-results',
  templateUrl: './multiple-results.component.html',
  styleUrls: ['./multiple-results.component.css']
})
export class MultipleResultsComponent implements OnInit {
  public searchInfo = new Array<GeneralInfo>();
  selectedVin:string;
  public isFormOk:boolean=false;
  public showError:boolean=false;
  public  httpOptions =
  {
   headers: new HttpHeaders({
     'Content-Type':  'application/json',
   })
};
  constructor(public MultipleSubjectresult:MultipleResultServiceService,private router:Router,
    private spinnerService: Ng4LoadingSpinnerService,private TowService:TowLocateSubjectService,
    private client: HttpClient) { }

  ngOnInit() {
  
    this.MultipleSubjectresult.currentMessage.subscribe(message=>
      this.searchInfo= message);
    if (this.searchInfo.length==0) {
      this.router.navigate([`/HomePage`]);
    }
  }
  public GoBack()
  {
    this.router.navigate([`/HomePage`])

  }
  public Submit()
  {
    if (!this.isFormOk) {
      this.showError=true;
    }
    else
    {
      this.spinnerService.show();
      this.client.post<SearchByVinViewModel>('https://towlienapiprod.azurewebsites.net/api/TowLocate/SearchVin',JSON.stringify(this.selectedVin),this.httpOptions).subscribe(data=>{    
        this.TowService.changeMessage(data);
        this.spinnerService.hide();
    this.router.navigate([`/Results`])
  });

    }

  }
  onSelectedOptionsChange(value:GeneralInfo) 
  {
    this.isFormOk=true;
    if (this.showError) {
      this.showError=false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/Components/TowLocate/multiple-results/multiple-results.component.ts